import { getSentryOptions } from "@repo/error-tracking";

// NEXT_PUBLIC_* values must be referenced literally so Next.js inlines them
// into the browser bundle. The same values are used on the server and edge
// so every runtime reports to the same Sentry environment.
export const sentryOptions = getSentryOptions({
	dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
	environment:
		process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT ??
		process.env.NEXT_PUBLIC_VERCEL_ENV ??
		process.env.NODE_ENV,
	tracesSampleRate: process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE,
});
